import { Box, HStack, Text } from "@chakra-ui/react";
import { BaseBlockProps } from "./types";

interface KeyValuePair {
  key: string;
  value: string;
}

export const KeyValueBlock = ({ block }: BaseBlockProps) => {
  const content = block.content as { pairs?: KeyValuePair[] } | undefined;
  const pairs = content?.pairs || block.pairs || [];

  if (!pairs.length) return null;

  return (
    <Box>
      {pairs.map((pair: KeyValuePair, i: number) => (
        <HStack key={i} align="start" spacing="md" py={1}>
          <Text
            fontSize="xs"
            color="text.body.secondary"
            minW="120px"
            flexShrink={0}
          >
            {pair.key}
          </Text>
          <Text fontSize="xs" color="text.body.primary" fontWeight="500">
            {pair.value}
          </Text>
        </HStack>
      ))}
    </Box>
  );
};
